import React from 'react';
import { API_BASE_URL } from '../../helpers/ApiSettings';

const ProductTable = ({ products, onEdit, onDelete }) => {
  return (
    <div className="table-responsive">
      <table className="table">
        <thead>
          <tr>
            <th>Image</th>
            <th>Référence</th>
            <th>Titre</th>
            <th>Prix/jour</th>
            <th>Caution</th>
            <th>Stock</th>
            <th>Catégorie</th>
            <th>Statut</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {products.map((product) => (
            <tr key={product.id}>
              <td>
                {product.images && product.images[0] ? (
                  <img 
                    src={`${API_BASE_URL}${product.images[0].url}`}
                    alt={product.titre}
                    style={{ width: '50px', height: '50px', objectFit: 'cover' }}
                  />
                ) : (
                  <div 
                    className="bg-secondary"
                    style={{ width: '50px', height: '50px' }}
                  ></div>
                )}
              </td>
              <td>{product.reference}</td>
              <td>{product.titre}</td>
              <td>{product.daily_price}€</td>
              <td>{product.caution}€</td>
              <td>{product.quantity}</td>
              <td>{product.category?.name}</td>
              <td>
                <span className={`badge bg-${product.available ? 'success' : 'danger'}`}>
                  {product.available ? 'Disponible' : 'Indisponible'}
                </span>
              </td>
              <td>
                <div className="btn-group">
                  <button
                    className="btn btn-sm btn-info me-2"
                    onClick={() => onEdit(product)}
                    data-bs-toggle="modal"
                    data-bs-target="#editProductModal"
                  >
                    Modifier
                  </button>
                  <button
                    className="btn btn-sm btn-danger"
                    onClick={() => onDelete(product.documentId)}
                  >
                    Supprimer
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ProductTable;